var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalAndInternationalNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.57 12.85c.08 1.36 1.26 1.39 2.6 1.19.06 0 1-.23 1-.27s.31-.65-.21-.61a2.36 2.36 0 0 0-.85.07c-.26 0-1.27 0-1.39-.24a4.55 4.55 0 0 1 .08-1.11c0-.58.19-3.13-.39-3.11-1 0-.27.78-.74 3a7 7 0 0 0-.1 1.08Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22 8.77c-.1 0-.34 0-.43.39a13.4 13.4 0 0 0 .12 4.55.34.34 0 0 0 .68 0 10.69 10.69 0 0 0 .14-3c-.21-1.45-.22-1.88-.51-1.94Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.34 9.36c-1.08 3.8-.91 3.27-1 3.16 0 .08-1.4-2.87-1.41-3a.29.29 0 0 0-.28-.31c-.37 0-.35.38-.28.74s-.19-.67.95 3c.28.68.65 1.41 1.35 1.23.46-.12.6-.54.71-1L15 9.5a.34.34 0 0 0-.66-.14Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 9.64A14.54 14.54 0 0 0 20 9.5a.28.28 0 0 0 0-.42 4.92 4.92 0 0 0-1.61-.24c-.66-.05-1.16-.28-1.64.34a2.77 2.77 0 0 0-.3 1.66c-.09 4.11 0 3.71 3.51 3.32a.34.34 0 0 0 0-.68H17.9c-.37 0-.34.25-.36-.73 0-1.24 0-.28 1.06-.48.39-.07.72-.27 1.13-.35a.34.34 0 0 0 0-.67 5 5 0 0 0-2.17 0c.03-1.02-.19-1.59.17-1.61Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.27 5.51c0 .2-2.42-.26-6.57-.19a10.68 10.68 0 0 1 1.06-1.76C10 3.14 11 2.47 11.07 2.08S10 1.74 9.66 2.1a6.42 6.42 0 0 0-2.09 3.25c-.87 0-1.7.11-2.47.2-1 .15-1.69.7-.78.86 1-.07 2.07-.07 3 0-.11.49-.2 1-.26 1.43a.34.34 0 0 0 .66.14 14.94 14.94 0 0 1 .54-1.54l7.17.21c0 .4.09.8.14 1.21a.34.34 0 0 0 .68 0c0-.4.08-.79.12-1.19l3.9 0a.34.34 0 0 0 0-.68c-1 0-2.37-.15-3.85-.27A4.4 4.4 0 0 0 15 2.29a.3.3 0 1 0-.47.36 7.15 7.15 0 0 1 .74 2.86Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.92 17.29a11.13 11.13 0 0 0 0-2.17.3.3 0 0 0-.6 0 12.55 12.55 0 0 1-.38 2.19 75.21 75.21 0 0 1-8.22 0C7 15.4 7.3 14.93 6.83 15a.29.29 0 0 0-.26.32 13.72 13.72 0 0 0 .16 1.94c-1.85-.13-3.09-.38-3.76-.38s-.09.89.8.87c1 .2 2.07.39 3.16.53A7.93 7.93 0 0 0 8.26 21c.42.57 1.42 1.1 1.54.39a11.7 11.7 0 0 1-1.68-3 35 35 0 0 0 7.46 0c-.7 1.7-.7 1.93-1 2.5l0 .11c0 .93.81.67 1.29-.41a10.17 10.17 0 0 0 .92-2.32c1-.12 1.72-.23 2.42-.38 1.22-.18 1.67-1 .92-1a21.33 21.33 0 0 1-3.21.4Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 10.38a12.19 12.19 0 0 0-3.49-7 25.69 25.69 0 0 0-3.65-2.21.34.34 0 0 0-.3.61A24.24 24.24 0 0 1 19.91 4a11.32 11.32 0 0 1 3 6.55c.88 7.19-7 14.77-16.07 11C2.92 19.92.78 17 1 12.37 1.19 6.33 6.68.48 13.17 1a.3.3 0 0 0 .07-.6C2.57-1-3.09 11.16 1.75 18.57c1.6 2.46 4 3.73 6.84 4.65C16.51 25.67 25 18.49 23.9 10.38Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalAndInternationalNews);
export default __webpack_public_path__ + "static/media/national-and-international-news.6f88873b07ada18243e37870e9767c67.svg";
export { ForwardRef as ReactComponent };